<template>
    <div class="madrid-home">
        <div class="madrid-home__header">
            <div></div>
            <h1>{{title}}</h1>
            <div>
                <p>{{ description }}</p>
                <span></span>
            </div>
        </div>
        <div class="madrid-home__warning">
            <span>VERSIÓN EN PRUEBAS DEL AYUNTAMIENTO DE MADRID. SEGUIMOS TRABAJANDO</span>
        </div>
        <ul v-if="routes" class="madrid-home__routes">
            <li v-for="route in routes" :key="route">
                  <div :style="{ backgroundImage: `url(${route.image})` }" >
                      <div>
                          <div>
                              <div>
                                  <span>DISTRITO</span>
                                  <span>{{ route.locations.length }} PARADAS</span>
                              </div>
                              <p>{{ route.name }}</p>
                          </div>
                          <div @click="goToRoute(route)">
                              <span>VER RUTA</span>
                              <span></span>
                          </div>
                      </div>
                  </div>
            </li>
        </ul>

        <div class="madrid-home__bottom">
            <h1>
              Sumérgete en la historia de Madrid con sus rutas interactivas
            </h1>
            <div @click="scrollToTop()">
                <span>VOLVER ARRIBA</span>
                <span></span>
            </div>
            <div class="madrid-home__bottom--logo"></div>
            <span>v{{ appVersion }}</span>
        </div>
    </div>
</template>

<script src="./HomeComponent.ts" lang="ts"></script>
<style lang="scss" src="./HomeComponent.scss"></style>

